import { render } from "./AuditTrailTable.vue?vue&type=template&id=62ce9e99&scoped=true"
import script from "./AuditTrailTable.vue?vue&type=script&lang=js"
export * from "./AuditTrailTable.vue?vue&type=script&lang=js"

import "./AuditTrailTable.vue?vue&type=style&index=0&id=62ce9e99&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ce9e99"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTh,QBtn});
